import { type BoardsListOptions } from '@air/api/types';

/**
 * Synthetic id for the pseudo-library that groups workspace boards with no library assignment.
 * It is never sent to the API as a real library id.
 */
export const GENERAL_LIBRARY_ID = 'general';

/** Page size for every picker boards query — matches the previous general-library list. */
export const ITEM_PICKER_BOARDS_PAGE_LIMIT = 100;

/** Board fetch options shared by the content-area board sections so cards have cover images. */
export const ITEM_PICKER_BOARD_FETCH_PARAMS: Partial<BoardsListOptions> = {
  includeCoverImage: true,
  includeDirectDescendantBoardCount: true,
  isMemberOfBoard: 'ALL',
  limit: ITEM_PICKER_BOARDS_PAGE_LIMIT,
  numThumbnails: 1,
};
